<template>
	<div class="box">
		<h3 class="title is-3">
			Log Out
		</h3>
		<p>
			You are about to log out, are you sure you wish to proceed?	
		</p>
		<div class="field">
			<button class="button is-danger" @click.prevent="logout">
				Log Out
			</button>	
		</div>
	</div>
</template>

<script>
	import Authorization from './../lib/Authorization';

	export default {
		name: 'Logout',
		methods: {
			logout(){
				Authorization.clearToken(),
				window.location.reload();
			}
		}
	}
</script>